// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IMessageOfferSchema } from '../offer/MessageOfferSchema';

export interface IMessageSchema {
  /** признак, что сообщение может быть удалено **/
  canBeDeleted: boolean;
  /** Наименование бота **/
  chatBot?: EChatBot;
  /** Уникальный id коммуникации **/
  communicationId?: string;
  /** Дата создания сообщения в ISO формате **/
  created: string;
  /** Признак, что сообщение отправлено из чат-бота **/
  fromChatBot: boolean;
  /** признак, что сообщение отправлено из crm **/
  fromCrm: boolean;
  /** Текст сообщения c html разметкой **/
  htmlText?: string;
  /** Изображения **/
  images?: string[];
  /** Идентификатор сообщения **/
  messageId: string;
  /** Объявления; У сообщения может быть только одно объявление; Здесь лежит список из одного элемента **/
  offers?: IMessageOfferSchema[];
  /** Версия изменений **/
  rowVersion: number;
  /** Статус сообщения **/
  status: EStatus;
  /** Текст сообщения **/
  text?: string;
  /** Тип сообщения **/
  type: EType;
}

export enum EChatBot {
  /** Бот для общения об объектах с владельцем недвижимости **/
  'ConciergeBot' = 'conciergeBot',
  /** Бот КС **/
  'CsBot' = 'csBot',
  /** Бот для общения об объектах **/
  'ExpertBot' = 'expertBot',
  /** Бот общих вопросов **/
  'General' = 'general',
  /** Поисковый бот **/
  'SearchBot' = 'searchBot',
}
export enum EStatus {
  /** Удалено **/
  'Deleted' = 'deleted',
  /** Доставлено до сервера **/
  'DeliveredToServer' = 'deliveredToServer',
}
export enum EType {
  /** Сообщение с оффером **/
  'Offer' = 'offer',
  /** Текстовое сообщение **/
  'Text' = 'text',
  /** Сообщение с текстом и картинкой **/
  'TextAndImages' = 'textAndImages',
}
